export default __webpack_public_path__ + "images/white_bg-WcXrU.png";